"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sagas_1 = require("@/app/shared/store/global/sagas");
const sagas_2 = require("@/app/shared/store/notifications/sagas");
const sagas_3 = require("@/app/SUMO/store/scheduler/sagas");
const sagas_4 = require("@/app/SUMO/store/user/sagas");
const sagas_5 = require("@/app/SUMOCEP/store/scheduler/sagas");
const sagas_6 = require("@/app/SUMOCEP/store/user/sagas");
const effects_1 = require("redux-saga/effects");
function* rootSaga() {
    try {
        yield (0, effects_1.all)([
            (0, effects_1.fork)(sagas_1.watchGlobalSaga),
            (0, effects_1.fork)(sagas_2.watchNotificationsSaga),
            (0, effects_1.fork)(sagas_3.watchSUMO1SchedulerSaga),
            (0, effects_1.fork)(sagas_4.watchSUMO1UserSaga),
            (0, effects_1.fork)(sagas_5.watchSUMOCEPSchedulerSaga),
            (0, effects_1.fork)(sagas_6.watchSUMOCEPUserSaga),
        ]);
    }
    catch (error) {
        console.error(error);
    }
}
exports.default = rootSaga;
